import { Directive, Input, ElementRef, OnInit } from '@angular/core';
import { EcallStatus } from '../../model';

enum Status { CREATED = 'Created', RECEIVED = 'Received', ARRIVED = 'Arrived', COMPLETED = 'Completed', CANCELLED = 'Cancelled', UNKNOWN = 'Unknown'}

@Directive({
  selector: '[appEcallStatusNum2statusName]'
})
export class EcallStatusNum2statusNameDirective implements OnInit {

  @Input() status: any;

  constructor(private el: ElementRef) { }

  getStatusNameFromStatusNum(): Status {
    if (this.status === EcallStatus.created ) {
      return Status.CREATED;
    } else if (this.status === EcallStatus.received ) {
      return Status.RECEIVED;
    } else if (this.status === EcallStatus.arrived ) {
      return Status.ARRIVED;
    } else if (this.status === EcallStatus.completed ) {
      return Status.COMPLETED;
    } else if (this.status === EcallStatus.cancelled ) {
      return Status.CANCELLED;
    } else {
      return Status.UNKNOWN;
    }
  }

  ngOnInit() {
    const nativeElement: HTMLElement = this.el.nativeElement;
    nativeElement.innerText = this.getStatusNameFromStatusNum();
  }

}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/directives/ecall-statusnum2statusname/ecall-statusnum2statusname.directive.ts